<div class="sidebar-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>auction.bid.list</span>	
	</div>
	<div class="copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
	(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<!-- primary layout which is displayed by request-block-normal style on big resolutions -->
		<div class="request-block request-block-normal">
			<ng-container *ngFor="let offer of scroller.list">
				<ng-container *ngFor="let bundle of offer.bundles">
					<div *ngFor="let bid of bundle.bids" class="request-block-item">
						<div class="request-block-info1">
							<div class="request-block-info-item">
								<div class="bundle-heading" translate>auction.bundle.number</div>
								<div class="bundle-name">{{ bundle.name }}</div>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.name</div>
								<a class="request-block-value  copo-link" [routerLink]="['/auction', 'bidding', 'offer',
									offer.id,
									bid.soldTo.sapCode]">{{ offer.name }}</a>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.bid.week</div>
								<div class="request-block-value">{{ bid.creationDate ? (bid.creationDate | copoDate: 'week') : UNDERSCORE }}</div>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>need4steel.wizard.summary.product.price</div>
								<div class="request-block-value">{{ bid.price ? (bid.price | copoNumber: 'amount') : UNDERSCORE }}</div>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.transport.price</div>
								<div class="request-block-value">{{ bid.transportPrice ? (bid.transportPrice | copoNumber: 'amount') : UNDERSCORE }}</div>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.product.type</div>
									<div class="request-block-value">{{ offer.family ? offer.family : UNDERSCORE }}</div>
							</div>
							<div class="pill request-block-status status-padding" 
								[class.request-status-bg-awarded]="isAwarded(bid)"
								[class.request-status-bg-pending]="isPending(bid)"
								[class.request-status-bg-rejected]="isRejected(bid)">
								{{getAuctionOfferStatus(bid.status)}}
							</div>
						</div>
						<div class="request-block-info2">
							<div class="pill request-block-weight">
								<div class="request-block-status-label">
									<span>{{ bundle.weight |copoNumber:'weight':(UNIT_OPTIONS['to'].symbol )}}</span>
								</div>
							</div>
							<div class="request-block-info-item">
								<mat-icon class="mill-icon" svgIcon="icon_mill" color="accent"></mat-icon>
								<span class="request-block-value">{{ bundle.mill.name }}</span>
							</div>
							<div class="steelgrade-block-label" translate>auction.main.steelgrade</div>
							<div class="steelgrade-block">
								<ng-container *ngFor="let material of bundle.material; let i = index">
									<ng-container *ngIf="i < 3">
										<div class="pill request-block-steelgrade">
											<div class="request-block-status-label">
												<span>{{ material.material.steelgradeCommercialDescription ? material.material.steelgradeCommercialDescription : UNDERSCORE }}</span>
											</div>
										</div>
									</ng-container>	
								</ng-container>
								<mat-icon class="steelgrade-tooltip" svgIcon="md:more_vert" [matTooltip]="getSteelGradeDescription(bundle.material)"></mat-icon>
							</div>
							<a mat-button class="request-block-details" [routerLink]="['/auction', 'bidding', 'offer',
								offer.id,
								bid.soldTo.sapCode]">
								<span translate>quality.feedback.card.details</span>
								<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
							</a>
						</div>
					</div>	
				</ng-container>	
			</ng-container>
		</div>
		<!-- additional layout which is displayed by request-block-small style on smaller resolutions -->
		<div class="request-block request-block-small">
			<div *ngFor="let offer of scroller.list">
				<ng-container *ngFor="let bundle of offer.bundles">
					<div *ngFor="let bid of bundle.bids" class="request-block-item">
						<div class="request-block-info2">
							<div class="bundle-name-small">{{ bundle.name }}</div>
							<div class="pill request-block-weight">
								<div class="request-block-status-label">
									<span>{{ bundle.weight |copoNumber:'weight':(UNIT_OPTIONS['to'].symbol )}}</span>
								</div>
							</div>
							<div class="pill request-block-status status-padding" 
								[class.request-status-bg-awarded]="isAwarded(bid)"
								[class.request-status-bg-pending]="isPending(bid)"
								[class.request-status-bg-rejected]="isRejected(bid)">
								{{getAuctionOfferStatus(bid.status)}}
							</div>
						</div>
						<div class="request-block-info1">
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.name</div>
								<a class="request-block-value  copo-link" [routerLink]="['/auction', 'bidding', 'offer',
									offer.id,
									bid.soldTo.sapCode]">{{ offer.name }}</a>
							</div>
							<div class="request-block-info-item">
								<mat-icon class="mill-icon" svgIcon="icon_mill" color="accent"></mat-icon>
								<span class="request-block-value">{{ bundle.mill.name }}</span>
							</div>
						</div>
						<div class="request-block-info1">
							<div class="request-block-info-item">
								<div class="request-block-label" translate>need4steel.wizard.summary.product.price</div>
								<div class="request-block-value">{{ bid.price ? (bid.price | copoNumber: 'amount') : UNDERSCORE }}</div>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.transport.price</div>
								<div class="request-block-value">{{ bid.transportPrice ? (bid.transportPrice | copoNumber: 'amount') : UNDERSCORE }}</div>
							</div>
						</div>
						<div class="request-block-info1">
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.bid.week</div>
								<div class="request-block-value">{{ bid.creationDate ? (bid.creationDate | copoDate: 'week') : UNDERSCORE }}</div>
							</div>
							<div class="request-block-info-item">
								<div class="request-block-label" translate>auction.product.type</div>
								<div class="request-block-value">{{ offer.family ? offer.family : UNDERSCORE }}</div>
							</div>
						</div>
						<div class="request-col-full">
							<div class="steelgrade-block-label" translate>auction.main.steelgrade</div>
							<div class="steelgrade-block">
								<ng-container *ngFor="let material of bundle.material; let i = index">
									<ng-container *ngIf="i < 3">
										<div class="pill request-block-steelgrade">
											<div class="request-block-status-label">
												<span>{{ material.material.steelgradeCommercialDescription ? material.material.steelgradeCommercialDescription : UNDERSCORE }}</span>
											</div>
										</div>
									</ng-container>	
								</ng-container>
								<mat-icon class="steelgrade-tooltip" svgIcon="md:more_vert" [matTooltip]="getSteelGradeDescription(bundle.material)"></mat-icon>
							</div>
						</div>
						<a mat-button class="request-block-details" [routerLink]="['/auction', 'bidding', 'offer',
						offer.id,
						bid.soldTo.sapCode]">
							<span translate>quality.feedback.card.details</span>
							<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
						</a>
					</div>
				</ng-container>			
			</div>
		</div>
	</div>
	<div *ngIf="scroller.list.length < 1 && !isLoading" class="no-bid-text" translate>auction.offer.no.bids</div>
	<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
</div>